﻿import { BaseFiltering, Combobox, Fluent } from "@serenity-is/corelib";

BaseFiltering.prototype["getEditorText"] = function () {
    const input = this.get_container().querySelector(Fluent.inputLikeSelector + ":not(.select2-focusser):not(.select2-input)");
    if (!input) {
        return this.get_container().textContent?.trim();
    }
    let value;
    let combobox = Combobox.getInstance(input);
    if (combobox) {
        value = combobox.getSelectedItems()?.join(", ");
    }
    else {
        value = input.value;
    }
    return value;
}
